
import { Component, Inject } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-desc-dialog',
  templateUrl: './desc-dialog.component.html',
  styleUrls: ['./desc-dialog.component.scss']
})
export class DescDialogComponent {
  // public dialogRef: MatDialogRef<DescDialogComponent>;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any) {
  }


}
